import { Dialog } from "@dash/dialog";
import { Button, TextField } from "@dash/form";
import { useEffect, useState } from "react";
import type { FC } from "react";

type Props = {
  productLabel: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (serialNumber: string | null) => void;
};

export const SupportTicketAddProductSerialDialog: FC<Props> = ({
  productLabel,
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [draft, setDraft] = useState("");

  useEffect(() => {
    if (isOpen) {
      setDraft("");
    }
  }, [isOpen, productLabel]);

  if (!isOpen) {
    return null;
  }

  const confirm = () => {
    onConfirm(draft.trim() || null);
  };

  return (
    <Dialog header={productLabel} onClose={onClose} css={{ width: "22rem" }}>
      <div css={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <TextField
          label="Numer seryjny (opcjonalny)"
          value={draft}
          onChange={setDraft}
          autoFocus
          inputElementProps={{
            onKeyDown: (event) => {
              if (event.key === "Enter") {
                confirm();
              }
            },
          }}
        />
        <div css={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
          <Button variant="text" onClick={onClose}>
            Anuluj
          </Button>
          <Button onClick={confirm}>Dodaj</Button>
        </div>
      </div>
    </Dialog>
  );
};
